/*
* @Author: zhangzhitao
* @Date: 2019-04-29 14:36:46
 * @Last Modified by: zhenghong7
 * @Last Modified time: 2019-09-17 14:39:41
*/

<template>
  <div
    class="m-store-outer"
    :class="{'is-open':!isLock}"
    @mouseover="showToolBar"
    @mouseout="hideToolBar"
  >
    <div class="m-store-wrap">
      <div class="m-header">
        <img
          v-if="systemLogoInfo.fileId!=='-1'"
          :src="systemLogoInfo.path"
        ><span>{{$t('management.dataView.data_view_config')}}</span>
        <i
          class="u-icon iconfont"
          :class="{'u-unlock':!lockSwitch,'iconb_ic_guding':!lockSwitch,'iconcommon_guding_f':lockSwitch,' brand-color':lockSwitch}"
          @click="lockSwitch=!lockSwitch"
        ></i>
      </div>
      <tag-filter
        :tags="tags"
        @filter="handleFilterTag"
      ></tag-filter>
      <div class="m-store-content">
        <el-scrollbar
          wrap-class="m-scroll-wrap"
          :size="0"
        >
          <widgets-group
            v-for="(group,index) in widgetGroup"
            :key="index"
            :widgets="group.widgetList"
            :disabled="disabled"
            :componentName="group.componentName"
            @preview="handleWidgetPreview"
            @preview-close="handlePreviewClose"
          ></widgets-group>
        </el-scrollbar>
        <div
          class="m-preview-box"
          v-if="previewFlag"
          :style="`top:${previewTop+scrollTop}px`"
        >
          <div class="m-widget-header">{{activeWidget.name}}</div>
          <div class="m-widget-ctn">
            <img
              :src="activeWidget.previewImage"
              @error="defaultPicError"
              v-if="!showDefault"
              alt=""
            >
            <div
              class="error-img"
              v-if="showDefault"
            >
              <img src="../../../../assets/images/default_no_image.png">
              <span>{{$t('management.dataView.has_no_widget_img')}}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="m-footer">
        <el-tooltip
          class="item"
          :content="$t('management.dataView.all_config')"
          placement="top"
        >
          <span
            class="u-icon"
            @click="handleOpenSysConfig"
          >
            <i class="h-icon-setting"></i>
          </span>
        </el-tooltip>
        <span class="u-line"></span>
        <el-tooltip
          class="item"
          :content="$t('management.dataView.clear_canvas')"
          placement="top"
        >
          <span
            class="u-icon"
            @click="handleCleanCanvas"
          >
            <i class="h-icon-delete"></i>
          </span>
        </el-tooltip>
        <span class="u-line"></span>
        <el-tooltip
          class="item"
          :content="$t('common.save')"
          placement="top"
        >
          <span
            class="u-icon"
            @click="handleSave"
          >
            <i class="h-icon-save"></i>
          </span>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import widgetsGroup from './widgets-group'
import tagFilter from './tag-filter'
import API from 'api/api'
export default {
  name: 'widget-store',

  props: {
    scrollTop: {
      type: Number,
      default: () => {
        return 0
      }
    },
    disabled: Boolean
  },

  data () {
    return {
      // 部件类型
      widgetTags: [{ value: '1', label: '列表' }, { value: '2', label: 'echarts' }, { value: '3', label: 'GIS' }],
      // 选中的部件类型
      activeTags: [],
      // 预览窗口开关
      previewFlag: false,
      // 预览窗口top值
      previewTop: 0,
      // 当前被拖拽的部件tag
      activeWidget: {},
      // 标签
      tags: [],
      // 部件组
      widgetGroup: [],
      isLock: true,
      lockSwitch: true,
      widgetGroupBack: [],
      systemLogoInfo: {
        fileId: '-1',
        path: ''
      },
      showDefault: false
    }
  },
  computed: {
    previewStyle () {
      return {
        'background-image': `url(${this.activeWidget.previewImage})`
      }
    }
  },
  components: { widgetsGroup, tagFilter },

  mounted () {
    this.getThemeInfo()
    this._getWidgetList()
  },

  methods: {
    defaultPicError () {
      this.showDefault = true
    },
    // 获取系统logo
    getThemeInfo () {
      API.theme.query().then(res => {
        this.systemLogoInfo = res.data.systemLogoInfo
      })
    },
    // 筛选
    handleFilterTag (filters) {
      this.widgetGroup = JSON.parse(JSON.stringify(this.widgetGroupBack))
      let _widgetGroup = []
      this.widgetGroup.forEach(group => {
        let _group = JSON.parse(JSON.stringify(group))
        _group['widgetList'] = []
        group.widgetList.forEach(widget => {
          for (let i = 0; i < widget.tagList.length; i++) {
            let widgetTag = widget.tagList[i]
            if (filters.indexOf(widgetTag) > -1) {
              _group['widgetList'].push(widget)
              break
            }
          }
        })
        _widgetGroup.push(_group)
      })
      this.widgetGroup = JSON.parse(JSON.stringify(_widgetGroup))
    },
    // 打开预览窗口
    handleWidgetPreview (widget, top) {
      let winH = document.getElementById('app').offsetHeight
      let _top = top - 48
      let _maxTop = winH - 400
      this.activeWidget = widget
      this.previewTop = top > _maxTop ? _maxTop - 48 : _top
      this.previewFlag = true
      this.showDefault = false
    },
    // 关闭预览窗口
    handlePreviewClose () {
      this.previewFlag = false
    },
    // 是否锁定工具栏
    showToolBar () {
      if (!this.lockSwitch) {
        this.isLock = true
        this.$root.$emit('changeTipWidth', this.isLock)
      }
    },
    hideToolBar () {
      if (!this.lockSwitch) {
        this.isLock = false
        this.$root.$emit('changeTipWidth', this.isLock)
      }
    },
    // 获取所有部件
    _getWidgetList () {
      API.dataView.getWidgetList().then(res => {
        this.widgetGroup = res.data.componentWidgetsInfoList
        this.widgetGroup.forEach(group => {
          group.widgetList.forEach(item => {
            if (item.name === '总户数') {
              item.resizable = true
              item.width = 200
              item.height = 300
            }
          })
        })
        this.widgetGroupBack = JSON.parse(JSON.stringify(this.widgetGroup))
        this.tags = res.data.tagList || []
      })
    },
    handleOpenSysConfig () {
      this.$emit('openSysConfig')
    },
    // 清空画布
    handleCleanCanvas () {
      this.$emit('clean')
    },
    // 保存
    handleSave () {
      this.$emit('save')
    }
  }
}

</script>

<style lang="less" scoped>
@import "../../../../assets/styles/wi-font/iconfont.css";
.m-store-outer {
  position: absolute;
  left: 0;
  top: 0;
  width: 376px;
  height: 100%;
  z-index: 6;
  transition: all 0.3s;
  &.is-open {
    left: -320px;
  }
  .m-store-wrap {
    display: flex;
    flex-direction: column;
    width: 320px;
    height: 100%;
    background: rgba(37, 37, 37, 0.95);
    box-sizing: border-box;
    .m-store-content {
      padding: 0 16px;
      width: 100%;
      flex: 1;
      /deep/ .m-scroll-wrap {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
      }
      .m-preview-box {
        position: absolute;
        left: 328px;
        top: 170px;
        width: 580px;
        height: 400px;
        padding: 8px;
        box-sizing: border-box;
        background: #f5f5f5;
        border-radius: 4px;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2),
          0 2px 4px 0 rgba(0, 0, 0, 0.12);
        .m-widget-header {
          width: 100%;
          height: 32px;
          color: #fff;
          font-size: 14px;
          line-height: 32px;
          text-indent: 8px;
          background: rgba(0, 0, 0, 0.7);
        }
        .m-widget-ctn {
          position: relative;
          width: 100%;
          height: calc(~"100% - 32px");
          overflow: hidden;
          background: #ebebeb;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          img {
            width: 100%;
            height: 100%;
          }
          .error-img {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 100px;
            height: 92px;
            margin-left: -50px;
            margin-top: -46px;
            img {
              display: block;
              margin: 0 auto;
              width: 72px;
              height: 72px;
            }
            span {
              display: block;
              text-align: center;
              color: rgba(0, 0, 0, 0.5);
              width: 100%;
            }
          }
        }
      }
    }
    .m-header {
      position: relative;
      width: 100%;
      height: 24px;
      line-height: 24px;
      margin-top: 24px;
      padding: 0 16px;
      img {
        position: absolute;
        top: -8px;
        width: 40px;
        height: 40px;
      }
      span {
        color: #fff;
        font-size: 16px;
        margin-left: 52px;
      }
      .u-icon {
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        float: right;
        font-size: 24px;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: rgba(255, 255, 255, 0.06);
        }
        &:active {
          background: rgba(255, 255, 255, 0.12);
        }
      }
    }
    .m-footer {
      position: fixed;
      bottom: 0;
      display: flex;
      flex-direction: row;
      width: 320px;
      height: 47px;
      line-height: 47px;
      text-align: center;
      font-size: 24px;
      color: rgba(255, 255, 255, 0.4);
      border-top: 1px solid rgba(255, 255, 255, 0.08);
      .u-icon {
        flex: 1;
        cursor: pointer;
        &:hover {
          color: rgba(255, 255, 255, 0.4);
          background: rgba(255, 255, 255, 0.08);
        }
      }
      .u-line {
        display: inline-block;
        width: 1px;
        height: 16px;
        background: rgba(255, 255, 255, 0.12);
        margin-top: 16px;
      }
    }
  }
}
</style>
